export function hasAtMostNDecimals(num: number, decimals: number): boolean {
  if (!Number.isFinite(num)) {
    return false;
  }
  const factor = 10 ** decimals;
  return Math.abs(num * factor - Math.round(num * factor)) < Number.EPSILON;
}
